/**
 * Deterministic shuffle so option order varies per question but stays stable on back navigation.
 */
export const shuffleWithSeed = (items, seed) => {
  const arr = [...items];
  let state = Math.abs(Number(seed) || 1) % 2147483646;

  for (let i = arr.length - 1; i > 0; i -= 1) {
    state = (state * 16807) % 2147483647;
    const j = state % (i + 1);
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }

  return arr;
};

export const shuffleQuestionOptions = (question) => {
  if (!question?.options?.length) return [];
  const seed = (Number(question.id) || 0) * 9973 + 42;
  return shuffleWithSeed(question.options, seed);
};
